export const data = {
    meetingPlaces: [],
    countries: [],
    phonePrefixes: []
}